// extracted by mini-css-extract-plugin
export default {"deal-icon":"KeyDealsCard_deal-icon__5LQCM"};